import { render, staticRenderFns } from "./ReportReservations.vue?vue&type=template&id=06286f2a&"
import script from "./ReportReservations.vue?vue&type=script&lang=js&"
export * from "./ReportReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports